import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE } from "./logout-cooldown-limit.action";
import {
	LogoutCooldownLimit,
	LogoutCooldownLimitState,
	LogoutCooldownLimitStatus,
} from "./logout-cooldown-limit.model";

const INITIAL_STATE: LogoutCooldownLimitState = {};

export function logoutCooldownLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): LogoutCooldownLimitState {
	switch (action.type) {
		case LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.getSuccess: {
			const limits: LogoutCooldownLimit[] = action.payload.limits;

			if (limits.length) {
				const activeLogoutCooldownLimit = limits.find(
					(limit) => limit.status === LogoutCooldownLimitStatus.Active
				);
				const queuedLogoutCooldownLimit = limits.find(
					(limit) => limit.status === LogoutCooldownLimitStatus.Queued
				);

				const hasAnyLimit = activeLogoutCooldownLimit !== undefined || queuedLogoutCooldownLimit !== undefined;

				return updateState(state, {
					...{ isLimitsHistoryEmpty: false },
					...(hasAnyLimit ? { activeLogoutCooldownLimit } : {}),
					...(hasAnyLimit ? { queuedLogoutCooldownLimit } : {}),
				});
			}

			return updateState(state, { isLimitsHistoryEmpty: true });
		}
		case LOGOUT_COOLDOWN_LIMIT_ACTION_TYPE.reset:
			return INITIAL_STATE;
		default:
			return state;
	}
}
